import { useFormContext } from "react-hook-form";

import ThemePaddingInput from "containers/admin/clients/client/theme-page/preview/components/theme-padding/theme-padding-input";
import { useThemePadding } from "containers/admin/clients/client/theme-page/preview/components/theme-padding/use-theme-padding";

import Icons from "assets";

interface ThemePaddingSimpleProps {
  formFieldPrefix: string;
}

const ThemePaddingSimple = ({ formFieldPrefix }: ThemePaddingSimpleProps) => {
  const { watch } = useFormContext();
  const { handleSimplePaddingChange } = useThemePadding(formFieldPrefix);

  // Watch form values for x and y directions
  const leftValue = watch(`${formFieldPrefix}.left`);
  const topValue = watch(`${formFieldPrefix}.top`);

  const handleBlur = (value: string, direction: "x" | "y") => {
    if (value === "") {
      handleSimplePaddingChange(direction, "0");
    }
    if (Number(value) > 60) {
      handleSimplePaddingChange(direction, "60");
    }
  };

  return (
    <div className="grid grid-cols-2 gap-2 w-full">
      <ThemePaddingInput
        value={leftValue}
        onChange={(value) => handleSimplePaddingChange("x", value)}
        onBlur={(value) => handleBlur(value, "x")}
        icon={<Icons.PaddingVertical className="size-4 rotate-90" />}
      />
      <ThemePaddingInput
        value={topValue}
        onChange={(value) => handleSimplePaddingChange("y", value)}
        onBlur={(value) => handleBlur(value, "y")}
        icon={<Icons.PaddingVertical className="size-4" />}
      />
    </div>
  );
};

export default ThemePaddingSimple;
